import { QueryClient } from '@tanstack/react-query';

// Create a client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Default stale time of 5 minutes
      staleTime: 5 * 60 * 1000,
      // Cache time of 15 minutes
      gcTime: 15 * 60 * 1000,
      // Retry failed queries 1 time
      retry: 1,
      // Retry delay (increases with each retry)
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
      // Don't refetch on window focus in development
      refetchOnWindowFocus: process.env.NODE_ENV === 'production',
      // Prefetch data
      refetchOnMount: true,
    },
  },
}); 